var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnalytics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 179,
    viewBox: "0 0 268 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M48.6494 172.637C67.9385 158.671 84.9027 139.541 84.9027 155.544C84.9027 171.548 78.2159 168.556 90.7131 159.412C113.525 142.716 117.694 146.607 130.08 156.573C148.431 171.341 188.962 153.528 213.453 139.592C235.337 127.139 267.821 120.553 266.975 135.423C266.061 151.484 265.283 172.647 265.283 172.647L48.6494 172.637Z",
    fill: "#EFF7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9248 178.018H265.286",
    stroke: "#808793",
    strokeWidth: 0.534054,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.726 59.2513C117.33 59.2513 117.819 58.7619 117.819 58.1583C117.819 57.5546 117.33 57.0652 116.726 57.0652C116.122 57.0652 115.633 57.5546 115.633 58.1583C115.633 58.7619 116.122 59.2513 116.726 59.2513Z",
    fill: "#8A7CB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.166 73.6674C139.152 66.4627 139.924 66.8485 139.924 66.8485L147 87.3085L134.78 110.205L124.628 113.166L111.769 74.1851L113.166 73.6674Z",
    fill: "#E6F2F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.158 75.3391C117.965 72.8247 138.624 67.7554 139.044 68.0363C139.463 68.3172 145.562 85.7687 145.562 85.7687C145.494 86.5403 147.386 86.0496 147.176 84.5775C146.966 83.1055 144.022 75.3289 143.812 74.2088C143.602 73.0887 140.658 65.3088 139.751 65.17C138.844 65.0313 129.101 66.6421 124.266 68.1141C119.43 69.5862 112.083 72.1073 111.372 72.8789C110.662 73.6505 110.391 74.3476 110.462 75.2477C110.533 76.1479 122.218 115.518 122.983 115.234C123.748 114.949 134.716 112.252 134.506 111.762C134.479 111.697 135.545 108.949 135.152 107.809C135.007 107.389 127.149 110.76 126.631 110.587C125.663 110.273 113.606 75.7012 114.158 75.3391Z",
    fill: "#D5DFE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.885 72.9635C109.23 74.3611 109.325 76.8179 110.015 78.8416C110.706 80.8653 121.115 111.528 121.298 111.785C122.313 113.203 123.084 111.914 123.013 111.24C122.983 110.943 110.831 76.6927 110.743 75.3696C110.687 74.5648 110.735 73.7561 110.885 72.9635Z",
    fill: "#38455B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.469 92.4124C138.963 90.7684 140.304 86.2675 138.465 82.3594C136.626 78.4513 132.303 76.6159 128.809 78.26C125.316 79.904 123.974 84.4049 125.813 88.313C127.652 92.2211 131.975 94.0565 135.469 92.4124Z",
    fill: "#3FC0E9"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M112.902 82.1884L110.808 76.0362L110.818 73.6538",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M110.817 73.6538C111.609 72.4186 116.14 70.6623 117.897 70.1073L110.817 73.6538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.193 81.735C166.275 81.9245 169.96 98.821 183.337 104.07C193.909 108.215 201.452 103.711 201.452 103.711C202.541 114.076 202.805 126.367 203.885 144.438C205.205 166.235 206.176 177.849 206.176 177.849H143.182L143.74 159.236C143.74 159.236 139.003 165.409 132.884 165.196C126.333 164.969 121.95 160.868 117.94 152.171C112.526 140.431 106.908 116.269 106.908 116.269L123.385 109.802L129.984 131.677C129.984 131.677 132.258 111.89 136.001 101.755C139.744 91.6198 144.373 86.7772 151.202 84.5742C158.031 82.3712 166.193 81.735 166.193 81.735Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.64,
    d: "M179.672 89.5453C194.068 85.7213 201.669 75.6064 199.811 64.4763C197.527 50.7675 181.178 54.7843 174.681 44.7709C157.795 18.7375 190.914 -6.09131 219.232 1.64801C247.824 9.47531 261.069 32.8963 257.651 61.2513C254.995 83.2882 245.008 98.1374 223.239 108.675C189.537 124.966 148.746 102.875 151.46 94.2288C154.16 85.6367 162.021 94.2288 179.672 89.5453Z",
    fill: "#D7ECF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.664 49.1905C151.453 47.221 145.175 54.3275 147.206 57.2919C148.248 58.8114 150.62 58.2665 151.605 56.4256C152.959 53.8876 153.104 49.9046 152.664 49.1905Z",
    stroke: "#38455B",
    strokeWidth: 0.548889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.492 46.6288C151.785 51.6778 150.258 55.5729 149.483 59.5863C148.708 63.5998 147.646 68.1954 149.216 70.4153C150.834 72.6961 155.155 72.1073 156.323 72.2359C157.49 72.3645 158.082 75.3255 160.021 82.5708C160.021 82.5708 165.822 81.5048 166.278 81.9244C166.278 81.9244 163.141 75.647 163.571 65.2343C163.822 59.143 167.141 49.864 167.141 49.864C167.141 49.864 160.871 50.0975 157.727 48.5916C156.57 48.076 155.483 47.4165 154.492 46.6288Z",
    fill: "#F7CA7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.227 105.498C178.156 104.252 172.728 96.8143 168.262 86.9667C164.377 78.405 163.121 71.7588 163.571 64.4425C164.021 57.1261 167.138 49.864 167.138 49.864C162.015 50.0806 158.367 49.0247 154.492 46.6288C147.311 42.1822 150.431 37.6712 158.214 36.6696C161.781 36.2127 172.427 34.4564 176.803 34.7846C181.178 35.1129 188.359 38.5071 188.796 44.9368C189.232 51.3665 185.233 64.165 187.811 68.7165C190.39 73.2681 199.138 72.6352 206.166 70.8417C212.934 69.1091 216.139 70.7706 217.124 77.5489C218.247 85.3153 210.173 107.552 190.227 105.498Z",
    stroke: "#38455B",
    strokeWidth: 0.548889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.603 52.9671C159.186 56.0906 162.124 57.0956 162.124 57.0956",
    stroke: "#38455B",
    strokeWidth: 0.548889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.272 121.23C146.16 138.871 145.811 139.115 143.842 158.888",
    stroke: "#5E646D",
    strokeWidth: 0.548889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.386 109.809C124.323 104.56 126.36 91.3558 125.142 89.481C123.924 87.6063 122.049 89.1054 121.673 90.794C121.298 92.4827 119.893 97.2609 118.77 98.3845C117.646 99.508 116.519 97.7279 116.063 96.4183C115.606 95.1087 111.278 82.7129 111.278 82.7129C111.163 85.5359 110.728 88.3367 109.981 91.0614C108.763 95.5622 108.912 98.1983 109.007 101.762C109.102 105.325 110.53 114.844 110.53 114.844L123.386 109.809Z",
    fill: "#F7CA7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.202 84.5809C147.869 83.0242 143.866 78.4896 142.742 78.625C141.619 78.7603 141.311 79.3289 141.48 80.3813C141.649 81.4337 143.822 83.7315 144.387 84.4861C144.961 85.3167 145.469 86.1914 145.906 87.102C145.906 87.102 148.275 85.613 149.358 85.2543C150.681 84.8144 151.202 84.5809 151.202 84.5809Z",
    fill: "#F7CA7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.75 95.1155C113.22 81.136 110.252 76.4761 110.817 73.6538C111.383 70.8315 137.054 64.6353 139.694 65.0617C141.007 65.2749 145.318 78.8416 146.022 80.537",
    stroke: "#38455B",
    strokeWidth: 0.548889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.993 112.086C132.993 112.086 132.567 112.344 124.942 114.32",
    stroke: "#38455B",
    strokeWidth: 0.548889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.138 49.864C175.686 48.3716 172.342 43.8471 170.319 44.8623C168.792 45.6238 167.138 49.864 167.138 49.864Z",
    fill: "white",
    stroke: "#38455B",
    strokeWidth: 0.548889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.392 114.147C127.776 113.278 131.705 111.971 133.444 111.531L133.122 113.494C132.635 113.833 124.869 116.364 124.811 115.887L124.392 114.147Z",
    fill: "#38455B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.092 86.6317C111.153 90.9869 112.76 97.5452 112.76 97.5452",
    stroke: "#38455B",
    strokeWidth: 0.548889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.676 92.7229C109.592 96.5537 109.592 98.0528 109.592 98.0528",
    stroke: "#38455B",
    strokeWidth: 0.548889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.985 131.683C129.511 139.084 127.954 150.157 127.954 150.157",
    stroke: "#5E646D",
    strokeWidth: 0.548889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.608 86.811L133.547 88.124L134.086 81.498",
    stroke: "white",
    strokeWidth: 1.10074,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0672 59.187C48.7863 59.187 52.6119 55.3614 52.6119 50.6423C52.6119 45.9232 48.7863 42.0976 44.0672 42.0976C39.3481 42.0976 35.5225 45.9232 35.5225 50.6423C35.5225 55.3614 39.3481 59.187 44.0672 59.187Z",
    fill: "#E58BB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4878 71.6403C90.1212 71.6403 92.256 69.5056 92.256 66.8722C92.256 64.2388 90.1212 62.1041 87.4878 62.1041C84.8545 62.1041 82.7197 64.2388 82.7197 66.8722C82.7197 69.5056 84.8545 71.6403 87.4878 71.6403Z",
    fill: "#8A7CB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.234 5.22727L111.148 14.313L120.234 23.3988L129.32 14.313L120.234 5.22727Z",
    fill: "#3FC0E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.885 44.6491C130.038 44.6491 130.973 43.7143 130.973 42.5612C130.973 41.408 130.038 40.4732 128.885 40.4732C127.732 40.4732 126.797 41.408 126.797 42.5612C126.797 43.7143 127.732 44.6491 128.885 44.6491Z",
    fill: "#E58BB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.38386 57.6033C4.537 57.6033 5.47181 56.6685 5.47181 55.5153C5.47181 54.3622 4.537 53.4274 3.38386 53.4274C2.23071 53.4274 1.2959 54.3622 1.2959 55.5153C1.2959 56.6685 2.23071 57.6033 3.38386 57.6033Z",
    fill: "#8A7CB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1189 87.0089L19.417 92.5108L21.3309 95.1901L29.0328 89.6882L27.1189 87.0089Z",
    fill: "#3FC0E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6926 35.2413L82.96 27.0442L80.1084 28.6905L84.841 36.8876L87.6926 35.2413Z",
    fill: "#8A7CB2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.629 21.6308C47.7821 21.6308 48.7169 20.696 48.7169 19.5429C48.7169 18.3897 47.7821 17.4549 46.629 17.4549C45.4758 17.4549 44.541 18.3897 44.541 19.5429C44.541 20.696 45.4758 21.6308 46.629 21.6308Z",
    fill: "#3FC0E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4532 92.459C63.6063 92.459 64.5411 91.5242 64.5411 90.371C64.5411 89.2179 63.6063 88.2831 62.4532 88.2831C61.3 88.2831 60.3652 89.2179 60.3652 90.371C60.3652 91.5242 61.3 92.459 62.4532 92.459Z",
    fill: "#E58BB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.537 27.536C173.371 28.5512 173.929 28.761 174.281 28.5512C174.633 28.3414 174.863 27.1198 174.508 26.8321C174.153 26.5445 173.642 26.8863 173.537 27.536Z",
    fill: "#38455B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.876 26.8084C177.706 27.8237 178.248 27.9996 178.617 27.8237C178.928 27.6849 179.202 26.3888 178.844 26.1012C178.485 25.8135 177.981 26.1587 177.876 26.8084Z",
    fill: "#38455B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.24 30.9877C175.724 31.475 176.973 31.1772 177.778 30.2331",
    stroke: "#38455B",
    strokeWidth: 0.548889,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M152.959 56.3884C149.616 57.7894 151.247 60.7471 152.729 61.2377C154.211 61.7284 157.206 60.72 156.79 58.6286C156.533 57.3122 154.888 55.5762 152.959 56.3884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M180.773 28.0876C179.28 28.7102 180.008 30.03 180.671 30.25C181.335 30.47 182.668 30.0199 182.485 29.0859C182.374 28.5072 181.639 27.7492 180.773 28.0876Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M171.998 29.14C170.509 29.7661 171.233 31.0858 171.896 31.3058C172.56 31.5258 173.893 31.0723 173.71 30.1383C173.602 29.5529 172.864 28.7644 171.998 29.14Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 157.781,
    y1: 44.683,
    x2: 155.896,
    y2: 200.749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1D6E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#8BBBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#83C3EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6ED7C3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 267.012,
    height: 178.018,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.73f2c2b7e56ee4974f86f3051f59d717.svg";
export { ForwardRef as ReactComponent };